import React, { useState } from 'react';
import * as dpService from 'features/dp/services/dpService';

/**
 * IFoodPanel – iFood bonus + fixed salary card inside the holerite.
 *
 * Props:
 *   holerite – full holerite object (includes funcionario, folha, ifood, liquido)
 */
export default function IFoodPanel({ holerite }) {
  const func = holerite.funcionario;
  const folha = holerite.folha;
  const competencia = folha?.competencia ?? '';

  const [fixo, setFixo] = useState(
    holerite.ifood
      ? String(holerite.ifood.salario_fixo || '')
      : String(func?.ifood_salario_fixo || '')
  );
  const [bonif, setBonif] = useState(
    holerite.ifood ? String(holerite.ifood.bonificacao || '') : ''
  );
  const [status, setStatus] = useState(null);

  const fmt = (v) => {
    const n = parseFloat(v) || 0;
    return 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const total = (parseFloat(fixo) || 0) + (parseFloat(bonif) || 0);
  const liquido = parseFloat(holerite.liquido) || 0;

  const salvar = () => {
    setStatus('salvando');
    const funcId = func?.id;
    if (!funcId) {
      setStatus('erro');
      return;
    }

    Promise.all([
      dpService.atualizarIfoodFixo(funcId, { valor: parseFloat(fixo) || 0 }),
      dpService.salvarIfoodBonificacao(funcId, {
        competencia,
        valor: parseFloat(bonif) || 0,
      }),
    ])
      .then(() => setStatus('ok'))
      .catch(() => setStatus('erro'));
  };

  return (
    <div className="mt-4 border border-orange-200 rounded-xl overflow-hidden">
      {/* Header */}
      <div className="bg-orange-500 px-4 py-2">
        <span className="text-white font-bold text-xs tracking-wide">CARTÃO IFOOD</span>
      </div>

      {/* Inputs row */}
      <div className="grid grid-cols-3 text-center border-b border-orange-200">
        {/* Bonificação */}
        <div className="p-3 border-r border-orange-200">
          <div className="text-xs text-gray-500 mb-1">Bonificação</div>
          <input
            type="number"
            value={bonif}
            onChange={(e) => setBonif(e.target.value)}
            placeholder="0,00"
            className="w-full text-center border border-orange-300 rounded px-2 py-1 text-sm font-medium text-orange-700 bg-orange-50"
          />
        </div>

        {/* Por Fora Fixo */}
        <div className="p-3 border-r border-orange-200">
          <div className="text-xs text-gray-500 mb-1">Por Fora Fixo (Salário)</div>
          <input
            type="number"
            value={fixo}
            onChange={(e) => setFixo(e.target.value)}
            placeholder="0,00"
            className="w-full text-center border border-orange-300 rounded px-2 py-1 text-sm font-medium text-orange-700 bg-orange-50"
          />
        </div>

        {/* Total iFood */}
        <div className="p-3">
          <div className="text-xs text-gray-500 mb-1">Total iFood</div>
          <div className="font-bold text-orange-600">{fmt(total)}</div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between px-4 py-3 bg-orange-50">
        <div className="text-sm">
          <span className="text-gray-600">Total Líquido / Cartão: </span>
          <span className="font-bold text-teal-700">{fmt(liquido + total)}</span>
        </div>

        <div className="flex items-center gap-2">
          {status === 'ok' && (
            <span className="text-xs text-green-600">✓ Salvo!</span>
          )}
          {status === 'erro' && (
            <span className="text-xs text-red-600">Erro ao salvar</span>
          )}
          <button
            onClick={salvar}
            disabled={status === 'salvando'}
            className="px-4 py-1.5 text-xs bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:opacity-50 font-medium"
          >
            {status === 'salvando' ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
}
